__turbopack_context__.v({
  "desktopTableOnly": "JfK-lG_desktopTableOnly",
  "headerText": "JfK-lG_headerText",
  "hideWeb": "JfK-lG_hideWeb",
  "inactive": "JfK-lG_inactive",
  "infoIcon": "JfK-lG_infoIcon",
  "mobileTableOnly": "JfK-lG_mobileTableOnly",
  "rowBox": "JfK-lG_rowBox",
  "rowText": "JfK-lG_rowText",
  "thumb": "JfK-lG_thumb",
  "unavailableText": "JfK-lG_unavailableText",
  "wrapper": "JfK-lG_wrapper",
});
